import styled from 'styled-components/macro';
import { NavLink } from 'react-router-dom';

const MaterialListItemStyled = styled(NavLink)`
  position: relative;
  display: inline-block;
  margin-bottom: 10px;
  text-decoration: none;
  transition: border-color 0.15s ease-out;
  cursor: pointer;

  &.active {
    cursor: default;
  }
`;

export default MaterialListItemStyled;
